var map = {
	"./Background.png": 74,
	"./Background2.png": 75,
	"./Background3.png": 76,
	"./Heidelberg.png": 77,
	"./Linotype.jpg": 78,
	"./Linotype.png": 79,
	"./PEERLESS.00_03_51_14.Still003.png": 80,
	"./Peerless_Platen.png": 25,
	"./ShawPen.png": 11,
	"./Vandercook.png": 81,
	"./Wharfedale.png": 26,
	"./brush.jpg": 82,
	"./brushmmkn.png": 83,
	"./heidelberg.jpg": 84,
	"./learn-button.png": 22,
	"./man.jpg": 23,
	"./man2.jpg": 85,
	"./printText.png": 27,
	"./scroll-image.jpg": 20,
	"./tools-overview.jpg": 86,
	"./tools.png": 87,
	"./typewriter.png": 21,
	"./vandercook.jpg": 88,
	"./vandercook2.jpg": 89,
	"./work-button.png": 24
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 12
// module chunks = 0